import { NOT_KNOWN } from '../../converters/crmSearch/FilterCRMSearchOperatorTypesType';
import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import FormattedMessage from 'I18n/components/FormattedMessage';
import QuickFiltersTags from './QuickFiltersTags';
import NotKnown from 'customer-data-filters-ui/filterQueryFormat/operator/NotKnown';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersNoValueDisplay = props => {
  const {
    onValueDelete,
    condition,
    use
  } = props;
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataFiltersUI.quickFilters.enumUnassigned"
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return condition.constructor === NotKnown ? label : null;
  }
  let tags = [];
  if (condition.constructor === NotKnown) {
    tags = [{
      value: NOT_KNOWN,
      label
    }];
  }
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersNoValueDisplay;